<template>
  <div class="item-layout" @click="$emit('item-click', item)">
    <b-icon :icon="item.icon"></b-icon>
    <h4 class="body-text item-layout__text">{{ item.text }}</h4>
  </div>
</template>

<script lang="ts">
import { ItemMenu } from '@/store/navigation/types'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'MenuItem',
  props: {
    item: {
      type: Object as PropType<ItemMenu>,
      required: true
    }
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style
.item-layout
    display: flex
    flex-direction: row
    justify-content: flex-start
    align-content: center
    align-items: center
    width: 100%
    border-bottom: 1px solid $strokes
    background: $white
    padding: 16px 10px

    &:active
      background: $primary
      color: $white

    &__text
      padding-left: 12px
</style>
